// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Dealer } from './dealer';
import { Order } from './order';
import { Payment } from './payment';
import { PaymentCreditType } from './payment-credit-type';
import { PaymentLine } from './payment-line';

/// <code-import> Place custom imports between <code-import> tags
import { Invoice } from './invoice';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PaymentCredit extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  balance: number = 0;
  creditOrderInvoices: Invoice[] = [];
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  applied?: Date;
  appliedToPaymentId?: number;
  availableAmount!: number;
  created!: Date;
  createdBy?: string;
  creditAmount!: number;
  creditOrderId?: number;
  dealerId!: number;
  deleted?: Date;
  deletedBy?: string;
  fromPaymentId?: number;
  notes?: string;
  paymentCreditTypeId!: number;
  quickBooksExport?: Date;
  quickBooksId?: string;
  appliedToPayment!: Payment;
  creditOrder!: Order;
  dealer!: Dealer;
  fromPayment!: Payment;
  paymentCreditType!: PaymentCreditType;
  paymentLines!: PaymentLine[];
}

